export default "__VITE_ASSET__BsjC8ms$__"